module.exports = __webpack_public_path__ + "static/media/averta-semibold.afe34790.woff2";